export default {
  computed: {
    translations() {
      return {
        searchQuery: {
          tag: this.$t("components.tools.vlex.search_form.add_new_query"),
        },
        jurisdiction: {
          label: this.$t("components.tools.vlex.search_form.jurisdiction"),
          placeholder: `${this.$t("actions.select")} ${this.$t("components.tools.vlex.search_form.jurisdiction")}`,
        },
        sub_jurisdiction: {
          label: this.$t("components.tools.vlex.search_form.sub_jurisdiction"),
          placeholder: `${this.$t("actions.select")} ${this.$t("components.tools.vlex.search_form.sub_jurisdiction")}`,
        },
        content_type: {
          label: this.$t("components.tools.vlex.search_form.content_type"),
          placeholder: `${this.$t("actions.select")} ${this.$t("components.tools.vlex.search_form.content_type")}`,
        },
        sort: {
          label: this.$t("components.tools.vlex.search_form.sort"),
          placeholder: this.$t("components.tools.vlex.search_form.sort"),
        },
        groups: {
          all: this.$t("components.tools.vlex.search_form.groups.all"),
          entities: this.$t("components.tools.vlex.search_form.groups.entities"),
          sort: this.$t("components.tools.vlex.search_form.groups.sort") ,
        },
        cards: {
          jurisdiction: this.$t("components.tools.vlex.search_results.cards.jurisdiction"),
          court: this.$t("components.tools.vlex.search_results.cards.court"),
          docket_number: this.$t("components.tools.vlex.search_results.cards.docket_number"),
          date: this.$t("components.tools.common.date"),
          judgment_date: this.$t("components.tools.vlex.search_results.cards.judgment_date"),
          view_document: this.$t("components.tools.vlex.search_results.cards.view_document"),
        }
      };
    },
  },
};
